export class Screens {

    constructor() { }

    public ScreenID: number;
    public ScreenName: string;
    public ScreenRoute: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/screens.model.ts